var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProjectsInactive = function SvgProjectsInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250 0C111.93 0 0 111.93 0 250s111.93 250 250 250 249.85-112 250-250S388.07 0 250 0m0 474.78C125.85 474.78 25.22 374.14 25.22 250S125.85 25.22 250 25.22 474.66 125.91 474.78 250 374.15 474.78 250 474.78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M414.61 222.53 277.48 85.4a38.88 38.88 0 0 0-55 0L85.37 222.52a38.87 38.87 0 0 0 0 55l137.12 137.1a38.88 38.88 0 0 0 55 0l137.11-137.1a38.88 38.88 0 0 0 .01-54.99M301.1 301.05a72.23 72.23 0 1 1 0-102.16 72.24 72.24 0 0 1-.03 102.19z"
  })));
};
export default SvgProjectsInactive;